import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { PRESET_QUERY_KEY } from './use-get-preset';
import { fetchApi } from '@/requests/api';
import { BASE_DASHBOARD_URL } from '@/requests/constants';
import type { AllPresets, GetCurrentPresetSchema } from '../schema';

export function useDeletePreset<
  TPresetIdentifier extends keyof AllPresets,
  TSchema extends
    GetCurrentPresetSchema<TPresetIdentifier> = GetCurrentPresetSchema<TPresetIdentifier>,
>(
  options?: UseMutationOptions<
    void,
    Error,
    // could for some reason not use pick, so this is the easiest alternative
    {
      key: TSchema['key'];
      owner: TSchema['owner'];
      context: TPresetIdentifier;
    }
  >
) {
  return useMutation({
    ...options,
    mutationKey: [PRESET_QUERY_KEY],
    mutationFn: async ({ owner, key }) => {
      const res = await fetchApi({
        url: `${BASE_DASHBOARD_URL}/presets`,
        method: 'DELETE',
        body: JSON.stringify({
          owner,
          key,
        }),
      });
      if (!res.ok) throw new Error('Failed to remove preset');
    },
  });
}
